import React from 'react'

import ImageWithText from '@/components/flows/WalkthroughFlow/components/ImageWithText'
import screenshotUrl from '@/components/flows/WalkthroughFlow/steps/3_ReferralEngineScreen1/screenshot.png'

const ReferralEngineScreen1: React.FC = () => (
  <ImageWithText
    imageUrl={screenshotUrl}
    text={
      <p className="mb-4">
        Track all referral activity on RQ. View every case, track key details,
        and see insights by relationship, service, and professional type.
      </p>
    }
  />
)

export default ReferralEngineScreen1
